define("shared/utils/formatters/ig-post-from-dynamo", ["exports", "later/models/ig-post"], function (_exports, _igPost) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/models/ig-post"eaimeta@70e063a35619d71f

  /**
   * Converts a raw dynamo post into an igPost with analytics
   *
   */
  function createIgPostFromDynamo(obj, socialProfile) {
    const impressions = obj.carousel_album_impressions || obj.impressions;
    const reach = obj.carousel_album_reach || obj.reach;
    const savedCount = obj.carousel_album_saved || obj.saved;
    const videoViews = obj.carousel_album_video_views || obj.video_views;
    const attrs = {
      timeCollected: Date.now(),
      hasMedia: true,
      socialProfile,
      id: obj.id,
      createdTime: Number(obj.created_time),
      type: obj.type,
      followersOnPost: obj.followers_on_post,
      isStory: false,
      isCarousel: obj.type === 'carousel',
      isDeleted: obj.is_deleted,
      linkinbioPostId: obj.linkinbio_post_id,
      linkinbioMediaId: obj.linkinbio_media_id,
      thumbUrl: obj.permanent_image_url || obj.image_square_url,
      imageUrl: obj.permanent_image_url || obj.image_medium_url || obj.image_square_url,
      engagement: convertToNumberOrUndefined(obj.engagement_rate),
      impressions: convertToNumberOrUndefined(impressions),
      reach: convertToNumberOrUndefined(reach),
      savedCount: convertToNumberOrUndefined(savedCount),
      videoViews: convertToNumberOrUndefined(videoViews),
      shareCount: convertToNumberOrUndefined(obj.share_count),
      commentCount: convertToNumberOrUndefined(obj.comment_count),
      likeCount: convertToNumberOrUndefined(obj.like_count),
      followersCount: obj.followers_on_post,
      standardResUrl: obj.image_medium_url,
      instagramLink: obj.link,
      caption: obj.caption
    };
    return _igPost.DynamoIgPost.create(attrs);
  }

  function convertToNumberOrUndefined(input) {
    return input ? Number(input) : undefined;
  }

  var _default = createIgPostFromDynamo;
  _exports.default = _default;
});